import useForm from "../Hooks/useForm";
import { useHistory } from "react-router-dom";
import Logo from "../Assets/Images/cloudvidia.png";
import LoginInput from "../Components/Input";
import LanguageDropdown from "../Components/LanguageDropdown/LanguageDropdown";

import { Form } from "react-bootstrap";
import { PostData } from "../Api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [error, SetError] = useState("");
  const [rememberMeStatus, SetRememberMeStatus] = useState(false);
  const submit = (values) => {
    PostData("api/auth/login", values, true)
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        if (data && data.token) {
          localStorage.setItem("token", data.token);
          localStorage.setItem("currentMenu", '#dashboard');
          localStorage.setItem("refreshToken", data.refreshToken);
          history.push("/dashboard");
        }
      })
      .catch((error) => {
        SetError("Invalid Login");
        // console.log("error - - - - - -", error);
      });
      
  };

  const RememberMeHandleChange = () => {
    let userName = document.getElementById("username").value;
    let password = document.getElementById("password").value;
    if (!rememberMeStatus) {
      localStorage.setItem("rememberMe", true);
      localStorage.setItem("username", userName);
      localStorage.setItem("password", password);
    } else {
      localStorage.removeItem("username");
      localStorage.removeItem("password");
      localStorage.removeItem("rememberMe");
    }
    SetRememberMeStatus(!rememberMeStatus);
  };

  const { state, handleChange, handleSubmit, OnLoadForm } = useForm(submit); // add validation func, initState as argum

  useEffect(() => {
    let isRememberMeSet = localStorage.getItem("rememberMe"),
      userName = localStorage.getItem("username"),
      password = localStorage.getItem("password");
    if (isRememberMeSet === "true" && userName !== "" && password !== "") {
      OnLoadForm("username", userName);
      OnLoadForm("password", password);
      document.getElementById("username").value =
        localStorage.getItem("username");
      document.getElementById("password").value =
        localStorage.getItem("password");
      SetRememberMeStatus(true);
    }
  }, [rememberMeStatus]);

  return (
    <div className="wrapper">
      <div className="login-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col12 text-center logo">
              <img src={Logo} alt="" />
            </div>
            <div className="row">
              <div className="col12">
                <form onSubmit={handleSubmit} noValidate>
                  <div className="form-container">
                    <LoginInput
                      state={state}
                      handleChange={handleChange}
                      name="username"
                      label={t("LT_e_mail_address")}
                      id="username"
                      type="text"
                    />
                    <LoginInput
                      state={state}
                      handleChange={handleChange}
                      name="password"
                      label={t("LT_password")}
                      id="password"
                      type="password"
                    />
                    <div className="error-message">{error}</div>

                    <div className="row forgot-password-container">
                      <div className="col-6">
                        <Form.Check
                          type={"checkbox"}
                          id={`rememberme`}
                          label= {t("LT_remember_me")}
                          checked={rememberMeStatus}
                          onChange={RememberMeHandleChange}
                        />
                      </div>
                      <div className="col-6 forgot-password-link">
                        <a href="javascript:void(0)" className="link">
                          {t("LT_forgot_password")}
                        </a>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col12 text-center">
                        <button type="submit" className="submit-btn">
                          {t("LT_login")} 
                        </button>
                      </div>
                      <div className="col12 text-center privacy-policy-container">
                        <a href="javascript:void(0)" className="link">
                          {t("LT_term_of_use")}.{" "}
                        </a>
                        <a href="javascript:void(0)" className="link">
                          {t("LT_privacy_policy")}
                        </a>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cv-language-dropdown">
        <LanguageDropdown/>
      </div>
    </div>
  );
};

export default Login;
